import { render, staticRenderFns } from "./LandingCreation.vue?vue&type=template&id=bbdd9890&scoped=true&"
import script from "./LandingCreation.vue?vue&type=script&lang=js&"
export * from "./LandingCreation.vue?vue&type=script&lang=js&"
import style0 from "./LandingCreation.vue?vue&type=style&index=0&id=bbdd9890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdd9890",
  null
  
)

export default component.exports